export default __webpack_public_path__ + "static/media/part-night.3fe3e422.svg";